import { mapEventMetadata, NovaEventingProvider, NovaGraphQLProvider, } from '@nova/react';
import React from 'react';
import { useLazyLoadQuery } from './hooks/useLazyLoadQuery';
import { useFormattedAppPermissionsDialogStrings } from './types';
import { getAppHostNovaEventHandler } from './utilities/getAppHostNovaEventHandler';
export const AppHostNovaEventingProvider = ({ appDefinition, children, closeAppPermissionsDialog, currentAppDefaultPermissions, devicePermissionDialogResources, devicePermissionStorageService, hideRequestDialog, metaOSHubResources, setDevicePermissionsCapabilityItems, }) => {
    const formattedAppPermissionsDialogStrings = useFormattedAppPermissionsDialogStrings({
        appDefinition,
        metaOSHubResources,
    });
    const eventing = getAppHostNovaEventHandler({
        currentAppPermissions: {
            closeAppPermissionsDialog,
            devicePermissionsStorage: devicePermissionStorageService,
            setPermissionsState: setDevicePermissionsCapabilityItems,
        },
        hideRequestDialog,
    });
    const novaGraphQL = {
        useLazyLoadQuery: useLazyLoadQuery({
            devicePermissionDialogResources,
            currentAppPermissionsDialogResources: formattedAppPermissionsDialogStrings,
            currentAppDefaultPermissions: currentAppDefaultPermissions
                ? currentAppDefaultPermissions
                : [],
        }),
    };
    return (React.createElement(NovaEventingProvider, { eventing: eventing, reactEventMapper: mapEventMetadata },
        React.createElement(NovaGraphQLProvider, { graphql: novaGraphQL }, children)));
};
//# sourceMappingURL=AppHostNovaEventingProvider.js.map